// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Os1g","title":"styles_title__1bFaR"};